       
const parseError = ({ error, messageCallback, fallbackMessage }) => {
  // TODO/WARNING: Snackbars don't currently stack, and it looks like we need to use another library to get that to work properly (maybe)
  // https://stackoverflow.com/questions/70328972/how-to-dynamically-create-multiple-alerts-inside-mui-v5-snackbar
  const errorObj = error?.response?.data?.errors
  if (errorObj) {
    // Iterate through errors and render messages
    Object.values(errorObj).forEach((message) => {
      // If value is an array, loop through and render errors
      if (message instanceof Array) {
        message.forEach((nestedMessage) => {
          messageCallback({ message: nestedMessage, kind: 'error' })
        })
      } else {
        // If value is a single message, render normally
        messageCallback({ message, kind: 'error' })
      }
    })
  } else if (typeof error === 'string') {
    messageCallback({ message: error, kind: 'error' })
  } else {
    // Fallback message if none found
    messageCallback({ message: fallbackMessage, kind: 'error' })
  }
}

export default parseError
